import React from 'react';

const StatusDisplay = ({ status }) => {
  if (!status) return null;

  return (
    <div className={`status ${status.type}`}>
      {status.type === 'loading' && <div className="spinner" />}
      {status.message}
    </div>
  );
};

export default StatusDisplay;